<template>
  <RModal ref="modal" title="Create new invoice" :persistent="false" @hide="closeModal" @ok="onSave" @cancel="$event()">
    <Grid gtc="repeat(3, 1fr)" gtr="repeat(3, 1fr)" class="q-pt-md" gap="var(--r-space-md)">
      <RInput
        v-model="formData.issue_date"
        :disable="disable('issue_date')"
        label="Issue date"
        is-date
        no-feedback-icon
        no-hint
      />

      <RInput
        v-model="formData.due_date"
        :disable="disable('due_date')"
        label="Due date"
        is-date
        no-feedback-icon
        no-hint
      />

      <FileUploader v-model="formData.file" stack-label="Invoice file" />

      <RInput
        v-model="formData.approved_by"
        :disable="disable('approved_by')"
        label="Approved by"
        no-feedback-icon
        no-hint
      />

      <RInput
        v-model="formData.approval_date"
        :disable="disable('approval_date')"
        label="Approval date"
        is-date
        no-feedback-icon
        no-hint
      />

      <RInput
        id="create-invoice-modal-amount"
        :value="formattedAmount"
        label="Amount"
        no-feedback-icon
        no-hint
        on-clear="focus"
        @clear="clearAmount"
      />

      <RInput v-model="formData.paid_by" :disable="disable('paid_by')" label="Paid by" no-feedback-icon no-hint />

      <RInput
        v-model="formData.payment_date"
        :disable="disable('payment_date')"
        label="Payment date"
        is-date
        no-feedback-icon
        no-hint
      />

      <RInput
        v-model="formData.payment_reference"
        :disable="disable('payment_reference')"
        label="Payment reference"
        no-feedback-icon
        no-hint
      />
    </Grid>
  </RModal>
</template>
<script>
import { cloneDeep } from 'lodash'
import { LmFormObject } from '@lib/models/lm-form-object.class'
import { cleaveInstance } from '@/utils/cleave-instance'
// Components
import RModal from '@/ui/RModal'
import FileUploader from '@/reusable/FileUploader/FileUploader'
import * as apiTo from '@/modular-api'

export default {
  components: {
    RModal,
    FileUploader
  },

  props: {
    showing: {
      type: Boolean,
      default: false
    },
    disableProperties: {
      type: Array,
      default: () => []
    },
    entity: {
      type: Object,
      required: true
    },
    namespace: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      formattedAmount: null,
      formData: {},
      dataTemplate: {
        file: null,
        issue_date: null,
        due_date: null,
        approved_by: null,
        approval_date: null,
        paid_by: null,
        payment_date: null,
        payment_reference: null,
        amount: null
      },
      created: false,
      amountCleave: null
    }
  },

  computed: {
    modalShow: {
      get() {
        return this.showing
      },
      set(val) {
        !val && this.closeModal()
      }
    }
  },

  watch: {
    showing: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.showModal()
      }
    }
  },

  created() {
    this.$set(this, 'formData', new LmFormObject(this.dataTemplate))
  },

  methods: {
    showModal() {
      this.$refs.modal.show()
      this.$nextTick(() => {
        this.amountCleave = cleaveInstance.call(
          this,
          '#create-invoice-modal-amount .input-component .q-field__native',
          ({ target }) => {
            this.formData.amount = target.rawValue || null
            this.formattedAmount = target.value || null
          }
        )
      })
    },

    formatData() {
      let data = cloneDeep(this.formData)
      delete data.errors
      delete data.originalData
      if (!data.file) delete data.file
      data.issue_date = this.formatDateForPost(this.formData.issue_date, this.settings.date_format)
      data.due_date = this.formatDateForPost(this.formData.due_date, this.settings.date_format)
      data.approval_date = this.formatDateForPost(this.formData.approval_date, this.settings.date_format)
      data.payment_date = this.formatDateForPost(this.formData.payment_date, this.settings.date_format)
      data.amount = data.amount ? Number(data.amount) : null
      let formData = new FormData()
      this.formData.getFormData(formData, data)
      return formData
    },

    onSave(hide, setLoading) {
      setLoading(true)

      apiTo
        .CREATE_ADDITIONAL_INVOICE_FOR_ENTITY(this.namespace, this.entity.id, this.formatData())
        .then(() => {
          this.$emit('refresh')
          this.closeModal()
          hide()
        })
        .finally(() => setLoading(false))
    },

    closeModal() {
      this.$emit('close')
      this.created = false
      this.clearAmount()
      this.$set(this, 'formData', new LmFormObject(this.dataTemplate))
    },

    disable(key) {
      return this.disableProperties.includes(key)
    },

    clearAmount() {
      this.amountCleave.setRawValue(null)
    }
  }
}
</script>
